/* eslint-disable jsx-a11y/alt-text */
import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faHome, faGift, faCube, faAt, faCreditCard, faFileInvoice, faPlus, faUserPlus, faHistory, faCog, faQuestionCircle, 
    faToggleOn, faToggleOff, faMapMarkerAlt, faSlidersH, faUser, faMugHot, faWallet, faPencilAlt, faShoppingCart, faChartBar, 
    faMapMarkedAlt, faCheckCircle, faDotCircle, faCircle, faMoneyCheckAlt, faDonate, faRedo, faAmbulance, faDesktop, faStore, 
    faExchangeAlt, faSignOutAlt, faDharmachakra, faTimes, faCloudUploadAlt,  faPlusSquare, faMinusSquare, faInfo, faInfoCircle, faArrowUp, faArrowDown, faAngleDown, faAngleUp, faEye, faEyeSlash, faUserTimes, faPenAlt, faPen, faArrowRight, faReceipt, faKeyboard, faQrcode, faBars, faShoppingBag, faListAlt, faArrowLeft, faPhone, faPhoneAlt, faStoreAlt}
    from '@fortawesome/free-solid-svg-icons'
import { portalCfg } from '../../portal.router.config'
import { portal_config, custom_assets, domainName } from '../../portal.config'
import { isRetina } from '../utils/util';
import theme from '../theme.css';
import { SvgIcon } from '@material-ui/core'
import { custom_theme } from '../../portal.custom.page.config'

var defaultTheme = custom_theme && custom_theme.theme ? custom_theme.theme : theme;
console.log("defaultTheme ===", defaultTheme);

var iconStyle = {
    marginRight: defaultTheme.spacing * 2,
    marginBottom: 0,
}
var iconStyleRotate180 = {
    marginRight: defaultTheme.spacing * 2,
    marginBottom: 0,
    //transform: 'rotate(180deg)'
}
export const HomeIcon = (props) => {
    if (portal_config[domainName].replaceIconWithFont && portal_config[domainName].replaceIconWithFont.home) {
        return <FontAwesomeIcon icon={faHome} size="lg" color={defaultTheme.palette.icon.deactive} style={iconStyle} {...props} />
    } else {
        if (portal_config[domainName].usingLocalIcon) {
            var path = portalCfg.publicPath + '/assets';
            if (custom_assets[domainName].customIcon) {
                path = portalCfg.publicPath + '/custom_assets';
            }
            return <img style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/home.png", path + "/icons/home@2x.png")} {...props} />
        }
        return <FontAwesomeIcon icon={faHome} size="lg" color={defaultTheme.palette.icon.deactive} style={iconStyle} {...props}/>
    }
}

export const HomeActiveIcon = (props) => {
    console.log("defaultTheme.palette.icon.active===", defaultTheme.palette.icon.active)
    if (portal_config[domainName].replaceIconWithFont && portal_config[domainName].replaceIconWithFont.home) {
        return <FontAwesomeIcon icon={faHome} color={defaultTheme.palette.icon.active} size="lg" style={iconStyle} {...props} />
    } else {
        if (portal_config[domainName].usingLocalIcon) {
            var path = portalCfg.publicPath + '/assets';
            if (custom_assets[domainName].customIcon) {
                path = portalCfg.publicPath + '/custom_assets';
            }
            return <img style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/home_active.png", path + "/icons/home_active@2x.png")} {...props} />
        }
        return <FontAwesomeIcon icon={faHome} color={defaultTheme.palette.icon.active} size="lg" style={iconStyle} {...props} />
    }
}
export const OfferIcon = (props) => {
    if (portal_config[domainName].replaceIconWithFont && portal_config[domainName].replaceIconWithFont.home) {
        return <FontAwesomeIcon icon={faGift} size="lg" color={defaultTheme.palette.icon.deactive} style={iconStyle} {...props} />
    } else {
        if (portal_config[domainName].usingLocalIcon) {
            var path = portalCfg.publicPath + '/assets';
            if (custom_assets[domainName].customIcon) {
                path = portalCfg.publicPath + '/custom_assets';
            }
            return <img style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/offers.png", path + "/icons/offers@2x.png")} {...props} />
        }
        return <FontAwesomeIcon icon={faGift} size="lg" color={defaultTheme.palette.icon.deactive} style={iconStyle} {...props}/>
    }
}

export const OfferActiveIcon = (props) => {
    if (portal_config[domainName].replaceIconWithFont && portal_config[domainName].replaceIconWithFont.home) {
        return <FontAwesomeIcon icon={faGift} color={defaultTheme.palette.icon.active} size="lg" style={iconStyle} />
    } else {
        if (portal_config[domainName].usingLocalIcon) {
            var path = portalCfg.publicPath + '/assets';
            if (custom_assets[domainName].customIcon) {
                path = portalCfg.publicPath + '/custom_assets';
            }
            return <img style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/offers_active.png", path + "/icons/offers_active@2x.png")} {...props} />
        }
        return <FontAwesomeIcon icon={faGift} color={defaultTheme.palette.icon.active} size="lg" style={iconStyle} {...props} />
    }
}
export const GiftIcon = (props) => {
        return <FontAwesomeIcon icon={faGift} size="lg" color={defaultTheme.palette.icon.default} style={iconStyle} {...props} />
}

export const OrdersIcon = (props) => {
    if (portal_config[domainName].usingLocalIcon) {
        var path = portalCfg.publicPath + '/assets';
        if (custom_assets[domainName].customIcon) {
            path = portalCfg.publicPath + '/custom_assets';
        }
        return <img style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/order.png", path + "/icons/order@2x.png")} {...props} />
    }
    return <FontAwesomeIcon icon={faCube} size="lg" color={defaultTheme.palette.icon.deactive} style={iconStyle}  {...props}/>
}

export const OrdersActiveIcon = (props) => {
    if (portal_config[domainName].usingLocalIcon) {
        var path = portalCfg.publicPath + '/assets';
        if (custom_assets[domainName].customIcon) {
            path = portalCfg.publicPath + '/custom_assets';
        }
        return <img style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/order_active.png", path + "/icons/order_active@2x.png")} {...props} />
    }
    return <FontAwesomeIcon icon={faCube} color={defaultTheme.palette.icon.active} size="lg" style={iconStyle} {...props} />
}
export const MapIcon = (props) => {
    return <FontAwesomeIcon icon={faMapMarkerAlt} size="lg" color={defaultTheme.palette.icon.deactive} style={iconStyle}  {...props}/>
}

export const LocationsIcon = (props) => {
    return <FontAwesomeIcon icon={faMapMarkerAlt} size="lg" color={portal_config[domainName].customColorIcon ? portal_config[domainName].customColorIcon : defaultTheme.palette.primary.main} style={iconStyle} {...props}/>
}

export const MapActiveIcon = (props) => {
    return <FontAwesomeIcon icon={faMapMarkerAlt} color={defaultTheme.palette.icon.active} size="lg" style={iconStyle} {...props} />
}

export const ProfileIcon = (props) => <img style={{ height: 24, width: 24 }} src={isRetina(portalCfg.publicPath + "/assets/icons/profile.png", portalCfg.publicPath + "/assets/icons/profile@2x.png")} {...props} />
export const SettingIcon = (props) => {
    if (portal_config[domainName].usingLocalIcon) {
        var path = portalCfg.publicPath + '/assets';
        if (custom_assets[domainName].customIcon) {
            path = portalCfg.publicPath + '/custom_assets';
        }
        return <img style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/settings.png", path + "/icons/settings@2x.png")} {...props} />
    }
    return <FontAwesomeIcon icon={faCog} color={defaultTheme.palette.primary.main} size="lg" style={iconStyle} {...props} />
}

export const MyProfileIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img src={path + "/icons/contact.png"}  {...props}/>
}
export const ReferAFriendIcon = (props) => {
    if (portal_config[domainName].usingLocalIcon) {
        var path = portalCfg.publicPath + '/assets';
        if (custom_assets[domainName].customIcon) {
            path = portalCfg.publicPath + '/custom_assets';
        }
        return <img style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/refer_friend.png", path + "/icons/refer_friend@2x.png")} {...props} />
    }
    return <FontAwesomeIcon icon={faAt} color={defaultTheme.palette.primary.main} size="lg" style={iconStyle} {...props}/>
}
export const MyAccountIcon = (props) => {
    if (portal_config[domainName].usingLocalIcon) {
        var path = portalCfg.publicPath + '/assets';
        if (custom_assets[domainName].customIcon) {
            path = portalCfg.publicPath + '/custom_assets';
        }
        return <img style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/people.png", path + "/icons/people@2x.png")} {...props} />
    }
    return <FontAwesomeIcon icon={faUser} color={defaultTheme.palette.primary.main} size="lg" style={iconStyle} {...props}/>
}
export const RewardsTransactionsIcon = (props) => {
    if (portal_config[domainName].usingLocalIcon) {
        var path = portalCfg.publicPath + '/assets';
        if (custom_assets[domainName].customIcon) {
            path = portalCfg.publicPath + '/custom_assets';
        }
        return <img style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/receipt.png", path + "/icons/receipt@2x.png")} {...props} />
    }
    return <FontAwesomeIcon icon={faShoppingBag} color={defaultTheme.palette.primary.main} size="lg" style={iconStyle} {...props} />
}
export const OrderHistoryIcon = (props) => {
    if (portal_config[domainName].usingLocalIcon) {
        var path = portalCfg.publicPath + '/assets';
        if (custom_assets[domainName].customIcon) {
            path = portalCfg.publicPath + '/custom_assets';
        }
        return <img style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/history.png", path + "/icons/history@2x.png")} {...props} />
    }
    return <FontAwesomeIcon icon={faHistory} color={defaultTheme.palette.primary.main} size="lg" style={iconStyle} {...props}/>
}
export const NotificationsIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    // return <img style={{ height: 24, width: 24 }} src={path + "/icons/icon_bell.svg"} {...props} />
    return <SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
        <path fill="none" d="M0,0H24V24H0Z"/>
        <path fill={props.fill ? props.fill : defaultTheme.palette.tabBar.main} d="M21.454,18.143l-1.478-1.364V11.49a6.516,6.516,0,0,0-5.155-6.685V4.087a1.724,1.724,0,0,0-3.436,0v.719A6.5,6.5,0,0,0,6.231,11.49v5.288L4.753,18.143a1.05,1.05,0,0,0,.8,1.809H20.641a1.051,1.051,0,0,0,.813-1.809Zm-3.769-.307H8.522V11.49A4.482,4.482,0,0,1,13.1,6.731a4.482,4.482,0,0,1,4.582,4.76ZM13.1,23.125a2.215,2.215,0,0,0,2.291-2.115H10.813A2.208,2.208,0,0,0,13.1,23.125Z" transform="translate(-1.103 -0.625)"/>
    </SvgIcon>
}
export const LogoutIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    var customColorIcon = portal_config[domainName].customColorIcon ? portal_config[domainName].customColorIcon : null;
    // if(customColorIcon)
    //     return <FontAwesomeIcon icon={faSignOutAlt} color={customColorIcon} size="lg" style={iconStyle} />
    // else return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/exit.png", path + "/icons/exit@2x.png")} />
    return <SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
        <path fill="none" d="M0,0H24V24H0Z"/>
        <path fill={props.fill ? props.fill : defaultTheme.palette.icon.active} d="M10.79,16.29a1,1,0,0,0,1.41,0l3.59-3.59a1,1,0,0,0,0-1.41L12.2,7.7a1,1,0,0,0-1.41,1.41L12.67,11H4a1,1,0,0,0,0,2h8.67l-1.88,1.88A1,1,0,0,0,10.79,16.29ZM19,3H5A2,2,0,0,0,3,5V8A1,1,0,0,0,5,8V6A1,1,0,0,1,6,5H18a1,1,0,0,1,1,1V18a1,1,0,0,1-1,1H6a1,1,0,0,1-1-1V16a1,1,0,0,0-2,0v3a2.006,2.006,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V5A2.006,2.006,0,0,0,19,3Z"/>
    </SvgIcon>
}

export const ExpandMore = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img src={path + "/icons/expand_more.png"} {...props} />
}
export const ExpandLess = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img src={path + "/icons/expand_less.png"} {...props} />
}
export const CheckIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    //console.log('CheckIcon  path=',path)
    return <img style={{ height: 24, width: 24 }} {...props} src={isRetina(path + "/icons/check.png", path + "/icons/check@2x.png")} />
}

export const SuccessIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    //console.log('CheckIcon  path=',path)
    return <img style={{ height: 100, width: 100 }} {...props} src={isRetina(path + "/icons/success@2x.png", path + "/icons/success@3x.png")} />
}

export const ErrorIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    //console.log('CheckIcon  path=',path)
    return <img style={{ height: 100, width: 100 }} src={isRetina(path + "/icons/error.png", path + "/icons/error.png")} {...props} />
}
export const CheckIconPrimary = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/check_not_done.png", path + "/icons/check_not_done@2x.png")} {...props} />
}
export const FacebookIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ height: 24, width: 12 }} src={path + "/icons/facebook.png"} {...props} />
}
export const GoogleIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ height: 24, width: 24 }} src={path + "/icons/google.png"} {...props} />
}
export const MenuIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    // return <img {...props} src={path + "/icons/menu.png"} />
    return <FontAwesomeIcon icon={faBars} width={24} height={24} color={defaultTheme.palette.text.default} {...props}/>
}
export const WalletIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ height: 18, width: 18 }} src={isRetina(path + "/icons/wallet.png", path + "/icons/wallet@2x.png")} {...props} />
}

export const BarcodeScanIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/barcode-scan.png", path + "/icons/barcode-scan@2x.png")} {...props} />
}
export const UnitIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ height: 18, width: 18 }} src={isRetina(path + "/icons/redeem.png", path + "/icons/redeem@2x.png")} {...props} />
}

export const CyprusFlagIcon = (props) => <img style={{ height: 24, width: 24 }} src={isRetina(portalCfg.publicPath + "/assets/icons/cyprus_flag.png", portalCfg.publicPath + "/assets/icons/cyprus_flag@2x.png")} {...props} />
export const UKFlagIcon = (props) => <img style={{ height: 24, width: 24 }} src={isRetina(portalCfg.publicPath + "/assets/icons/uk_flag@2x.png", portalCfg.publicPath + "/assets/icons/uk_flag@2x.png")} {...props} />

export const ArrowDownIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ height: 12, width: 12, objectFit: 'contain' }} src={isRetina(path + "/icons/arrow_down.png", path + "/icons/arrow_down@2x.png")} {...props} />
}
export const ArrowRightIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img src={isRetina(path + "/icons/arrow_righ.png", path + "/icons/arrow_righ@2x.png")} {...props} />
}
export const CancelIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img src={isRetina(path + "/icons/cancel.png", path + "/icons/cancel@2x.png")} {...props} />
}
export const DeliveryIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ width: 24, height: 24 }} src={isRetina(path + "/icons/delivery.png", path + "/icons/delivery@2x.png")} {...props} />
}
export const PickUpIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ width: 24, height: 24 }} src={isRetina(path + "/icons/pickup.png", path + "/icons/pickup@2x.png")} {...props} />
}
export const OrderHeaderIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ width: 32, height: 32 }} src={isRetina(path + "/icons/raised_hand.png", path + "/icons/raised_hand@2x.png")} {...props} />
}
export const ShippingIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ width: 24, height: 24 }} src={isRetina(path + "/icons/local_shipping.png", path + "/icons/local_shipping@2x.png")} {...props} />
}
export const MopedIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ width: 24, height: 24 }} src={isRetina(path + "/icons/moped.png", path + "/icons/moped@2x.png")} {...props} />
}
export const TimeIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ width: 24, height: 24 }} src={isRetina(path + "/icons/time.png", path + "/icons/time@2x.png")} {...props} />
}


export const PlaceActiveIcon = (props) => {
    if (portal_config[domainName].usingLocalIcon) {
        var path = portalCfg.publicPath + '/assets';
        if (custom_assets[domainName].customIcon) {
            path = portalCfg.publicPath + '/custom_assets';
        }
        return <img style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/place_active.png", path + "/icons/place_active@2x.png")} {...props} />
    }
    return <FontAwesomeIcon icon={faMapMarkerAlt} color={defaultTheme.palette.primary.main} size="lg" style={iconStyle} {...props} />
}
export const PlaceActiveIcon2x = (props) => {
    // if (portal_config[domainName].usingLocalIcon) {
    //     var path = portalCfg.publicPath + '/assets';
    //     if (custom_assets[domainName].customIcon) {
    //         path = portalCfg.publicPath + '/custom_assets';
    //     }
    //     return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/place_active.png", path + "/icons/place_active@2x.png")} />
    // }
    return <FontAwesomeIcon icon={faMapMarkerAlt} color={'#db0000'} size="2x" style={iconStyle} {...props} />
}
export const LocationOnIcon = (props) => {
    // if (portal_config[domainName].usingLocalIcon) {
    //     var path = portalCfg.publicPath + '/assets';
    //     if (custom_assets[domainName].customIcon) {
    //         path = portalCfg.publicPath + '/custom_assets';
    //     }
    //     return <img {...props} style={{ height: 32, width: 32 }} src={isRetina(path + "/icons/location_on.png", path + "/icons/location_on@2x.png")} />
    // }
    return <FontAwesomeIcon icon={faMapMarkerAlt} color={'#db0000'} size="2x" style={iconStyle} {...props} />
}
export const LocationOnWhiteIcon = (props) => {
    return <FontAwesomeIcon icon={faMapMarkerAlt} color={'#fff'} width={48} height={48} style={iconStyle} {...props} />
}
export const BackOnPrimaryIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    // return <img {...props} style={{ width: 24, height: 24 }} src={isRetina(path + "/icons/arrow_back-24px.png", path + "/icons/arrow_back-24px@2x.png")} />
    return <SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
        <path fill="none" d="M24,0H0V24H24Z"/>
        <path fill={props.fill ? props.fill : defaultTheme.palette.text.light} d="M5.417,11h11.17l-4.88-4.88a1.008,1.008,0,0,1,0-1.42,1,1,0,0,1,1.41,0l6.59,6.59a1,1,0,0,1,0,1.41l-6.59,6.59a1,1,0,0,1-1.41-1.41L16.587,13H5.417a1,1,0,0,1,0-2Z" transform="translate(-0.418)"/>
    </SvgIcon>
}
export const BackIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ width: 24, height: 24 }} src={isRetina(path + "/icons/arrow_back_black@2x.png", path + "/icons/arrow_back_black@3x.png")} {...props} />
}
export const LeftIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ width: 24, height: 24 }} src={isRetina(path + "/icons/arrow_left.png", path + "/icons/arrow_left@2x.png")} {...props} />
}
export const PlaceIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ width: 24, height: 24 }} src={isRetina(path + "/icons/place.png", path + "/icons/place@2x.png")} {...props} />
}
export const PlaceBlackIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ width: 24, height: 24 }} src={isRetina(path + "/icons/place_black.png", path + "/icons/place_black@2x.png")} {...props} />
}
export const TuneIcon = (props) => {
    if (portal_config[domainName].usingLocalIcon) {
        var path = portalCfg.publicPath + '/assets';
        if (custom_assets[domainName].customIcon) {
            path = portalCfg.publicPath + '/custom_assets';
        }
        return <img style={{ height: 32, width: 32 }} src={isRetina(path + "/icons/tune.png", path + "/icons/tune@2x.png")} {...props} />
    }
    return <FontAwesomeIcon icon={faSlidersH} color={defaultTheme.palette.primary.main} size="lg" style={iconStyle} {...props} />
}
export const TuneWhiteIcon = (props) => {
    if (portal_config[domainName].usingLocalIcon) {
        var path = portalCfg.publicPath + '/assets';
        if (custom_assets[domainName].customIcon) {
            path = portalCfg.publicPath + '/custom_assets';
        }
        return <img style={{ height: 32, width: 32 }} src={isRetina(path + "/icons/tune_white.png", path + "/icons/tune_white@2x.png")} {...props} />
    }
    return <FontAwesomeIcon icon={faSlidersH} color={defaultTheme.palette.text.light} size="lg" style={iconStyle} {...props}/>
}
export const TocIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    // return <img style={{ width: 24, height: 24 }} src={isRetina(path + "/icons/toc.png", path + "/icons/toc@2x.png")} {...props} />
    return <FontAwesomeIcon icon={faListAlt} color={defaultTheme.palette.text.light} size="lg" style={iconStyle} {...props}/>
}
export const CurrentLocationIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img src={isRetina(path + "/icons/current_location.png", path + "/icons/current_location.png")} {...props} />
}
export const SwichGreenActiveIcon = (props) => {
    if (portal_config[domainName].usingLocalIcon) {
        var path = portalCfg.publicPath + '/assets';
        if (custom_assets[domainName].customIcon) {
            path = portalCfg.publicPath + '/custom_assets';
        }
        return <img style={{ height: 24, width: 44 }} src={isRetina(path + "/icons/switch_active_green.png", path + "/icons/switch_active_green@2x.png")} {...props} />
    }
    return <FontAwesomeIcon icon={faToggleOn} color={defaultTheme.palette.background.switch} size="2x" style={iconStyle} {...props} />
}

export const SwichActiveIcon = (props) => {
    if (portal_config[domainName].usingLocalIcon) {
        var path = portalCfg.publicPath + '/assets';
        if (custom_assets[domainName].customIcon) {
            path = portalCfg.publicPath + '/custom_assets';
        }
        return <img style={{ height: 24, width: 44 }} src={isRetina(path + "/icons/switch_active.png", path + "/icons/switch_active@2x.png")} {...props} />
    }
    return <FontAwesomeIcon icon={faToggleOn} color={defaultTheme.palette.primary.main} size="2x" style={iconStyle} {...props} />
}
export const SwichIcon = (props) => {
    if (portal_config[domainName].usingLocalIcon) {
        var path = portalCfg.publicPath + '/assets';
        if (custom_assets[domainName].customIcon) {
            path = portalCfg.publicPath + '/custom_assets';
        }
        return <img style={{ height: 24, width: 44 }} src={isRetina(path + "/icons/switch.png", path + "/icons/switch@2x.png")} {...props} />
    }
    return <FontAwesomeIcon icon={faToggleOff} color={defaultTheme.palette.background.switch} size="2x" style={iconStyleRotate180} {...props} />
}
export const CameraIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ width: 18, height: 18 }} src={isRetina(path + "/icons/camera.png", path + "/icons/camera@2x.png")} {...props} />
}
export const MaleIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ width: 19, height: 26 }} src={isRetina(path + "/icons/boy.png", path + "/icons/boy@2x.png")} {...props} />
}
export const FemaleIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ width: 19, height: 25 }} src={isRetina(path + "/icons/woman.png", path + "/icons/woman@2x.png")} {...props} />
}
export const EditIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ width: 24, height: 24 }} src={isRetina(path + "/icons/edit.png", path + "/icons/edit@2x.png")} {...props} />
}
export const EditWhiteIcon = (props) => <FontAwesomeIcon icon={faPencilAlt} color={defaultTheme.palette.text.default} size="lg" style={iconStyle} {...props}/>
export const EditWhiteMDIcon = (props) => <FontAwesomeIcon icon={faPencilAlt} color={defaultTheme.palette.text.light} size="md" style={iconStyle} {...props}/>
export const EditWhiteSmallIcon = (props) => <FontAwesomeIcon icon={faPencilAlt} color={defaultTheme.palette.text.default} size="sm" style={iconStyle} {...props}/>
export const HelpIcon = (props) => {
    if (portal_config[domainName].usingLocalIcon) {
        var path = portalCfg.publicPath + '/assets';
        if (custom_assets[domainName].customIcon) {
            path = portalCfg.publicPath + '/custom_assets';
        }
        return <img style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/help.png", path + "/icons/help@2x.png")} {...props} />
    }
    return <FontAwesomeIcon icon={faQuestionCircle} color={defaultTheme.palette.primary.main} size="lg" style={iconStyle} {...props} />
}
export const DeleteIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ width: 18, height: 18 }} src={isRetina(path + "/icons/delete.png", path + "/icons/delete@2x.png")} {...props} />
}

export const MailIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    // return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/mail.png", path + "/icons/mail@2x.png")} />
    return <SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
        <path fill="none" d="M0,0H24V24H0Z"/>
        <path fill={props.fill ? props.fill : defaultTheme.palette.tabBar.main} d="M19,6H17A5,5,0,0,0,7,6H5A2.006,2.006,0,0,0,3,8V20a2.006,2.006,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V8A2.006,2.006,0,0,0,19,6ZM12,3a3,3,0,0,1,3,3H9A3,3,0,0,1,12,3Zm7,17H5V8H19Zm-7-8A3,3,0,0,1,9,9H7A5,5,0,0,0,17,9H15A3,3,0,0,1,12,12Z"/>
    </SvgIcon>
}
export const WaveHandIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ width: 32, height: 32 }} src={isRetina(path + "/icons/waving-hand-sign.png", path + "/icons/waving_hand_sign@2x.png")} {...props} />
}
export const RisedHandIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ width: 32, height: 32 }} src={isRetina(path + "/icons/raised-hand_270b.png", path + "/icons/raised-hand_270b@2x.png")} {...props} />
}
export const PrivacyIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/policy.png", path + "/icons/policy@2x.png")} {...props} />
}
export const MailWhiteIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/mail_outline.png", path + "/icons/mail_outline@2x.png")} {...props} />
}
export const TermConditionIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/term_condition_white.png", path + "/icons/term_condition_white@2x.png")} {...props} />
}
export const FAQIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/fqa_outline.png", path + "/icons/fqa_outline@2x.png")} {...props} />
}
export const MoreInfoIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/more.png", path + "/icons/more@2x.png")} {...props} />
}
export const PhoneIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/phone_white.png", path + "/icons/phone_white@2x.png")} {...props} />
}
export const WebsiteIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img src={isRetina(path + "/icons/website.png", path + "/icons/website@2x.png")} {...props} />
}
export const WalletWhiteIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    // return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/wallet_white.png", path + "/icons/wallet_white@2x.png")} />
    return <SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
        <path fill="none" d="M0,0H24V24H0Z"/>
        <path fill={props.fill ? props.fill : defaultTheme.palette.text.light} d="M21,7.28V5a2.006,2.006,0,0,0-2-2H5A2,2,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2.006,2.006,0,0,0,2-2V16.72A2,2,0,0,0,22,15V9a2,2,0,0,0-1-1.72ZM20,9v6H13V9ZM5,19V5H19V7H13a2.006,2.006,0,0,0-2,2v6a2.006,2.006,0,0,0,2,2h6v2Z"/><circle class="b" cx="1.5" cy="1.5" r="1.5" transform="translate(14.5 10.5)"/>
    </SvgIcon>
}
export const PaymentsIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/payments.png", path + "/icons/payments@2x.png")} {...props} />
}
export const SpendingPreferenceIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img src={isRetina(path + "/icons/spending_light.png", path + "/icons/spending_light@2x.png")} style={{ height: 24, width: 24 }} {...props} />
}

export const ParticipatingSchemesIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/participating_schemes.png", path + "/icons/participating_schemes@2x.png")} {...props} />
}
export const AddressIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/address.png", path + "/icons/address@2x.png")} {...props} />
}
export const VisaIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ height: 15, width: 46 }} src={isRetina(path + "/icons/visa.png", path + "/icons/visa@2x.png")} {...props} />
}
export const DefaultCard = (props) => {
    var path = portalCfg.publicPath + '/assets';
    return <img style={{ height: 32, width: 32,objectFit:'contain' }} src={path + "/icons/card_icons/stp_card_unknown.png"} {...props} />
}
export const AmexIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    return <img style={{ height: 32, width: 32,objectFit:'contain' }} src={path + "/icons/card_icons/stp_card_amex.png"} {...props} />
}
export const DinnerIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    return <img style={{ height: 32, width: 32,objectFit:'contain' }} src={path + "/icons/card_icons/stp_card_diners.png"} {...props} />
}
export const DiscoverIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    return <img style={{ height: 32, width: 32,objectFit:'contain' }} src={path + "/icons/card_icons/stp_card_discover.png"} {...props} />
}
export const JCBIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    return <img style={{ height: 32, width: 32,objectFit:'contain' }} src={path + "/icons/card_icons/stp_card_jcb.png"} {...props} />
}
export const MasterCardIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    return <img style={{ height: 32, width: 32,objectFit:'contain' }} src={path + "/icons/card_icons/stp_card_mastercard.png"} {...props} />
}
export const VisaCardIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    return <img style={{ height: 32, width: 32,objectFit:'contain' }} src={path + "/icons/card_icons/stp_card_visa.png"} {...props} />
}
export const UnionPayIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    return <img style={{ height: 32, width: 32,objectFit:'contain' }} src={path + "/icons/card_icons/unionpay.png"} {...props} />
}
export const MasterIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ height: 32, width: 32,objectFit:'contain' }} src={isRetina(path + "/icons/master.png", path + "/icons/master@2x.png")} {...props} />
}
export const PaypalIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img src={isRetina(path + "/icons/paypal_logo.png", path + "/icons/paypal_logo@2x.png")} {...props} />
}
export const VNPayIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img src={isRetina(path + "/icons/vnpay.png", path + "/icons/vnpay.png")} {...props} />
}
export const DeleteWhiteIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ width: 18, height: 18 }} src={isRetina(path + "/icons/delete_outline.png", path + "/icons/delete_outline@2x.png")} {...props} />
}
export const AddIcon = (props) => {
    return <FontAwesomeIcon icon={faPlus} color={defaultTheme.palette.icon.active2} size="x" style={iconStyle} {...props} />
}
export const PersonAddIcon = (props) => {
    return <FontAwesomeIcon icon={faUserPlus} color={defaultTheme.palette.icon.active2} size="2x" style={iconStyle} {...props} />
}

export const CartItemIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ width: 24, height: 24 }} src={isRetina(path + "/icons/cart_item.png", path + "/icons/cart_item@2x.png")} {...props} />
}
export const AddCommentIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    // return <img {...props} style={{ width: 24, height: 24 }} src={isRetina(path + "/icons/add_comment.png", path + "/icons/add_comment@2x.png")} />
    return <SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
        <path fill="none" d="M0,0H24V24H0Z"/>
        <path fill={props.fill ? props.fill : defaultTheme.palette.text.light} d="M22,4a2.006,2.006,0,0,0-2-2H4A2.006,2.006,0,0,0,2,4V16a2.006,2.006,0,0,0,2,2H18l4,4ZM20,17.17,18.83,16H4V4H20ZM13,5H11V9H7v2h4v4h2V11h4V9H13Z"/>
    </SvgIcon>
}
export const HourglassIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img src={isRetina(path + "/icons/hourglass_top.png", path + "/icons/hourglass_top@2x.png")} {...props} />
}
export const HelloOrderIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ width: 165, height: 91 }} src={isRetina(path + "/icons/hello_order.png", path + "/icons/hello_order@2x.png")} {...props} />
}
export const CupIcon = (props) => {
    if (portal_config[domainName].usingLocalIcon) {
        var path = portalCfg.publicPath + '/assets';
        if (custom_assets[domainName].customIcon) {
            path = portalCfg.publicPath + '/custom_assets';
        }
        return <img style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/local_cafe-24px.png", path + "/icons/local_cafe-24px@2x.png")} {...props} />
    }
    return <FontAwesomeIcon icon={faMugHot} color={defaultTheme.palette.primary.main} size="lg" style={iconStyle} {...props} />
}
export const USAFlagIcon = (props) => <img style={{ width: 24, height: 24 }} src={isRetina(portalCfg.publicPath + "/assets/icons/usa_flag.png", portalCfg.publicPath + "/assets/icons/usa_flag@2x.png")} {...props} />
export const GREFlagIcon = (props) => <img style={{ width: 24, height: 24 }} src={isRetina(portalCfg.publicPath + "/assets/icons/greece_flag.png", portalCfg.publicPath + "/assets/icons/greece_flag@2x.png")} {...props} />
export const GoogleMapIcon = (props) => <img style={{ width: 36, height: 36 }} src={portalCfg.publicPath + "/assets/icons/google-maps.png"} {...props} />

export const RadioCheckedIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    // return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/radio_button_checked.png", path + "/icons/radio_button_checked@2x.png")} />
    return <SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
        <path fill="none" d="M0,0H24V24H0Z"/>
        <path fill={props.fill ? props.fill : defaultTheme.palette.primary.main} d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"/>
        <circle fill={props.fill ? props.fill : defaultTheme.palette.primary.main} cx="5" cy="5" r="5" transform="translate(7 7)"/>
    </SvgIcon>
}
export const RadioIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    // return <img {...props} style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/radio_unchecked.png", path + "/icons/radio_unchecked@2x.png")} />
    return <SvgIcon xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}>
        <path fill="none" d="M0,0H24V24H0Z"/>
        <path fill={props.fill ? props.fill : defaultTheme.palette.primary.main} d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"/>
    </SvgIcon>
}
export const RadioCheckedWhiteIcon = (props) => {

    return <FontAwesomeIcon icon={faCheckCircle} color={'#fff'} size="lg" style={{marginTop:-16, marginLeft:-16}} {...props}/>
}
export const RadioWhiteIcon = (props) => {

    return <FontAwesomeIcon icon={faCircle} color={'#fff'} size="lg" style={iconStyle} {...props} />
}
export const CartHomeIcon = (props) => <img {...props} style={{ height: 80, width: 80 }} src={portalCfg.publicPath + "/assets/images/online_shopping.png"} {...props} />
export const ShoppingCartIcon = (props) => <FontAwesomeIcon icon={faShoppingCart} color={'#000'} size="1x" style={iconStyle} {...props} />

export const FavoriteIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/favorite.png", path + "/icons/favorite@2x.png")} {...props} />
}
export const FavoriteActiveIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ height: 24, width: 24 }} src={isRetina(path + "/icons/favorite_active.png", path + "/icons/favorite_active@2x.png")} {...props} />
}
export const CardIcon = (props) => {
    return <FontAwesomeIcon icon={faCreditCard} color={defaultTheme.palette.icon.active} size="2x" style={iconStyle} {...props} />
}
export const TopupIcon = (props) => {
    return <FontAwesomeIcon icon={faDonate} color={defaultTheme.palette.primary.main} size="lg" style={iconStyle} {...props}/>
}
export const ReorderIcon = (props) => {
    return <FontAwesomeIcon icon={faRedo} color={'#3498db'} size="sm" style={iconStyle} {...props}/>
}
export const StarIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ height: 52, width: 52 }} src={isRetina(path + "/icons/start.png", path + "/icons/start@2x.png")} {...props} />
}
export const OrdersHomeIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ height: 52, width: 52, color: '#ffffff' }} src={isRetina(path + "/icons/orders.svg", path + "/icons/orders.svg")} {...props} />
}

export const ServiceRequestIcon = (props) => {
    var customColorIcon = portal_config[domainName].customColorIcon ? portal_config[domainName].customColorIcon : null;
    return <FontAwesomeIcon icon={faDharmachakra} color={customColorIcon ? customColorIcon : defaultTheme.palette.primary.main} size="lg" style={iconStyle} {...props}/>
}

export const RedeemPassIcon = (props) => {
    return <FontAwesomeIcon icon={faGift} color={defaultTheme.palette.primary.main} size="lg" style={iconStyle} {...props}/>
}
export const ReNewIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ height: 24, width: 24, color: '#ffffff' }} src={isRetina(path + "/icons/autorenew_black_24dp.svg", path + "/icons/autorenew_black_24dp.svg")} {...props} />
}
export const DateRangeBlackIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ height: 24, width: 24, color: '#ffffff' }} src={isRetina(path + "/icons/date_range_black_24dp.svg", path + "/icons/date_range_black_24dp.svg")} {...props} />
}
export const CalanderTodayBlackIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ height: 24, width: 24, color: '#ffffff' }} src={isRetina(path + "/icons/calendar_today_black_24dp.svg", path + "/icons/calendar_today_black_24dp.svg")} {...props} />
}
export const ReceiptBlackIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ height: 24, width: 24, color: '#ffffff' }} src={isRetina(path + "/icons/receipt_long_black_24dp.svg", path + "/icons/receipt_long_black_24dp.svg")} {...props} />
}

export const SubcriptionActiveIcon = (props) => {
    return <FontAwesomeIcon icon={faDesktop} color={defaultTheme.palette.icon.active} size="lg" style={iconStyle} {...props}/>
}

export const SubcriptionIcon = (props) => {
    return <FontAwesomeIcon icon={faDesktop} color={defaultTheme.palette.icon.deactive} size="lg" style={iconStyle} {...props}/>
}

// export const WalletJournalBlackIcon = (props) => {
//     var path = portalCfg.publicPath + '/assets';
//     if (custom_assets[domainName].customIcon) {
//         path = portalCfg.publicPath + '/custom_assets';
//     }
//     return <img {...props} style={{ height: 24, width: 24, color: '#6D1F37' }} src={isRetina(path + "/icons/ic24_sync.svg", path + "/icons/ic24_sync.svg")} />
// }
export const WalletJournalBlackIcon = (props) => {
    return <FontAwesomeIcon icon={faExchangeAlt} color={portal_config[domainName].customColorIcon ? portal_config[domainName].customColorIcon : defaultTheme.palette.primary.main} size="lg" style={iconStyle} {...props}/>
}

export const StoreActiveIcon = (props) => {
    return <FontAwesomeIcon icon={faStore} color={defaultTheme.palette.icon.active} size="lg" style={iconStyle} {...props}/>
}

export const StoreIcon = (props) => {
    return <FontAwesomeIcon icon={faStore} color={defaultTheme.palette.icon.deactive} size="lg" style={iconStyle} {...props}/>
}

export const ReOrderIconNew = (props) => <img src={portalCfg.publicPath + "/assets/icons/reorder.svg"} style={{width: 24, height: 24}} {...props}/>


export const ReOrderIconNew1 = (props) => {
    return <SvgIcon width="19.998" height="16" viewBox="0 0 31.99983 27" {...props}>
            <path d="M18.45783,0A13.53082,13.53082,0,0,0,4.92713,13.29712l-.0025.01245v.03662c-.00061.05176-.00781.10205-.00781.15381,0,.01367.00738.02515.00781.03857v4.48975L2.16,15.09277A1.25042,1.25042,0,1,0,.33967,16.80762l4.9248,5.22949c.00458.00488.01117.00635.01581.011l.0279.02734c.00469.00464.00616.011.011.01538a1.20328,1.20328,0,0,0,.18605.11743,1.21223,1.21223,0,0,0,.17328.1167l.00927.00635c.0058.00244.01288.00146.01874.00391a1.20844,1.20844,0,0,0,.93744-.00025l.01855-.00439.00666-.0044a1.20765,1.20765,0,0,0,.16632-.1123,1.1717,1.1717,0,0,0,.19659-.124c.005-.00463.00647-.01123.01135-.01611l.02717-.02783c.00445-.00488.0108-.00611.01519-.01074l4.90821-5.2295a1.24979,1.24979,0,1,0-1.82227-1.71093L7.42463,18.02148v-4.675A11.03794,11.03794,0,1,1,18.45783,24.5a1.25,1.25,0,0,0,0,2.5,13.50007,13.50007,0,1,0,0-27Z" />
        </SvgIcon>
}
export const WalletBlackIcon = (props) => {
    return <FontAwesomeIcon icon={faWallet} color={portal_config[domainName].customColorIcon ? portal_config[domainName].customColorIcon : defaultTheme.palette.primary.main} size="lg" style={iconStyle} {...props}/>
}
export const CloseIcon = (props) => {
    return <FontAwesomeIcon icon={faTimes} color={portal_config[domainName].customColorIcon ? portal_config[domainName].customColorIcon : defaultTheme.palette.primary.contrastText} size="md" style={iconStyle} {...props}/>
}
export const PKPassIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ height: 24}} src={isRetina(path + "/icons/apple_wallet.png", path + "/icons/apple_wallet.png")} {...props} />
}
export const GooglePayIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ height: 20, width: 20}} src={isRetina(path + "/icons/google_pay.png", path + "/icons/google_pay.png")} {...props}/>
}

export const StripeIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img src={isRetina(path + "/icons/stripe_logo.png", path + "/icons/stripe_logo.png")} {...props} />
}
export const FACIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img src={isRetina(path + "/icons/fac_logo.png", path + "/icons/fac_logo.png")} {...props} />
}
export const InvoiceIcon = (props) => {
    return <FontAwesomeIcon icon={faFileInvoice} color={defaultTheme.palette.icon.deactive} size="lg" style={iconStyle} {...props}/>
}
export const InvoiceActiveIcon = (props) => {
    return <FontAwesomeIcon icon={faFileInvoice} color={defaultTheme.palette.icon.active} size="lg" style={iconStyle} {...props}/>
}
export const UploadIcon = (props) => {
    return <FontAwesomeIcon icon={faCloudUploadAlt} color={defaultTheme.palette.text.default} style={{width: 50, height: 50}} {...props}/>
}

export const PlusIcon = (props) => <FontAwesomeIcon icon={faPlusSquare} color={'#ffffff'} size="lg" {...props}  />
export const MinusIcon = (props) => <FontAwesomeIcon icon={faMinusSquare} color={'#ffffff'} size="lg" {...props}  />
export const InformPasswordIcon = (props) => <FontAwesomeIcon icon={faInfoCircle} color={defaultTheme.palette.primary.main} size="md" {...props} />
export const UpIcon = (props) => {
    return <FontAwesomeIcon icon={faAngleUp} color={defaultTheme.palette.primary.main} size="lg" style={iconStyle} {...props}/>
}
export const DownIcon = (props) => {
    return <FontAwesomeIcon icon={faAngleDown} color={defaultTheme.palette.primary.main} size="lg" style={iconStyle} {...props}/>
}
export const EyeIcon = (props) => {
    return <FontAwesomeIcon icon={faEye} color={defaultTheme.palette.primary.main} size="md" style={iconStyle} {...props}/>
}
export const EyeSlashIcon = (props) => {
    return <FontAwesomeIcon icon={faEyeSlash} color={defaultTheme.palette.primary.main} size="md" style={iconStyle} {...props}/>
}
export const UpgradeIcon = (props) => {
    return <FontAwesomeIcon icon={faArrowUp} color={defaultTheme.palette.primary.main} size="lg" style={iconStyle} {...props}/>
}
export const DowngradeIcon = (props) => {
    return <FontAwesomeIcon icon={faArrowDown} color={defaultTheme.palette.primary.main} size="lg" style={iconStyle} {...props}/>
}
export const UserDeleteIcon = (props) => {
    return <FontAwesomeIcon icon={faUserTimes} color={defaultTheme.palette.text.light} size="lg" style={iconStyle} {...props}/>
}
export const EditIconCustom = (props) => {
    return <FontAwesomeIcon icon={faPen} color={defaultTheme.palette.primary.main} size="md" style={iconStyle} {...props}/>
}
export const ArrowRightFAIcon = (props) => {
    return <FontAwesomeIcon icon={faArrowRight} color={defaultTheme.palette.primary.contrastText} size="lg" style={iconStyle} {...props}/>
}
export const LotteryEventIcon = (props) => {
    var path = portalCfg.publicPath + '/assets';
    if (custom_assets[domainName].customIcon) {
        path = portalCfg.publicPath + '/custom_assets';
    }
    return <img style={{ height: 70, width: 70 }} src={isRetina(path + "/icons/lottery.svg", path + "/icons/lottery.svg")} {...props}/>
}
export const LotteryEventIconSvg = (props) => {
    return <SvgIcon width="188.000000pt" height="189.000000pt" viewBox="0 0 188.000000 189.000000" preserveAspectRatio="xMidYMid meet" {...props}>
        <g xmlns="http://www.w3.org/2000/svg" transform="translate(0.000000,189.000000) scale(0.100000,-0.100000)" fill={props.stroke ? props.stroke : "currentColor"} stroke="none">
            <path d="M915 1625 c-275 -79 -524 -151 -553 -160 -99 -31 -166 -118 -161 -211 3 -38 -1 -48 -28 -76 -62 -64 -63 -70 -63 -475 0 -236 4 -382 11 -408 14 -51 81 -116 136 -133 52 -15 1139 -17 1194 -2 106 29 149 99 156 253 l6 104 -44 24 c-42 23 -93 83 -86 102 2 6 57 25 123 44 131 37 175 64 207 127 27 51 25 129 -5 231 l-24 80 -49 13 c-85 24 -135 86 -135 167 0 53 10 77 53 122 33 36 33 41 -4 165 -25 86 -71 140 -136 162 -26 9 -58 16 -72 15 -14 0 -251 -65 -526 -144z m598 -4 c13 -16 29 -50 36 -75 11 -44 10 -49 -21 -103 -30 -53 -33 -65 -33 -143 0 -68 5 -93 22 -125 27 -50 86 -107 139 -133 43 -22 64 -64 64 -130 0 -68 -12 -73 -430 -192 -212 -61 -457 -131 -546 -156 -157 -45 -162 -46 -193 -30 -18 10 -36 27 -41 39 -28 63 -199 693 -194 712 12 50 41 61 459 180 226 65 460 132 520 151 142 43 185 44 218 5z m-1243 -633 c120 -448 144 -508 221 -553 65 -38 129 -28 499 79 184 53 343 99 352 102 13 4 23 -7 42 -44 13 -26 43 -65 66 -86 l42 -38 -4 -65 c-4 -57 -8 -69 -32 -89 l-27 -24 -575 0 -576 0 -29 29 -29 29 0 360 c0 198 3 367 6 376 10 27 21 9 44 -76z"/>
            <path d="M1080 1500 c-53 -53 13 -126 81 -90 13 7 19 21 19 44 0 59 -59 87 -100 46z"/>
            <path d="M1134 1295 c-21 -32 -11 -72 21 -87 35 -16 71 -3 85 32 10 25 10 34 -4 55 -23 35 -79 35 -102 0z"/>
            <path d="M1222 1118 c-43 -21 -43 -83 1 -108 64 -36 120 53 61 99 -30 24 -30 24 -62 9z"/>
            <path d="M1265 905 c-14 -13 -25 -31 -25 -40 0 -9 11 -27 25 -40 13 -14 31 -25 40 -25 9 0 27 11 40 25 14 13 25 31 25 40 0 9 -11 27 -25 40 -13 14 -31 25 -40 25 -9 0 -27 -11 -40 -25z"/>
        </g>
    </SvgIcon>
}

export const ReclaimIcon = (props) => {
    return <FontAwesomeIcon icon={faReceipt} size="lg" color={portal_config[domainName].customColorIcon ? portal_config[domainName].customColorIcon : defaultTheme.palette.primary.main} style={iconStyle} {...props}/>
}

export const ReclaimTransactionCodeIcon = (props) => {
    return <FontAwesomeIcon icon={faKeyboard} size="lg" color={defaultTheme.palette.text.onPrimary} style={{width: 30, height: 30}} {...props}/>
}

export const QRCodeScan = (props) => {
    return <FontAwesomeIcon icon={faQrcode} size="lg" color={defaultTheme.palette.text.onPrimary} style={{width: 30, height: 30}} {...props}/>
}
export const BackIconSvg = (props) => {
    return <FontAwesomeIcon icon={faArrowLeft} color={defaultTheme.palette.primary.main} size="md" style={iconStyle} {...props}/>
}
export const PhoneFA = (props) => {
    return <FontAwesomeIcon icon={faPhoneAlt} color={defaultTheme.palette.text.primary} size="md" style={iconStyle} {...props}/>
}
export const StoreAltIcon = (props) => {
    return <FontAwesomeIcon icon={faStoreAlt} color={defaultTheme.palette.text.primary} size="md" {...props}/>
}
export const SearchIcon = (props) => {
    return (
        <SvgIcon xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill={props.fill ? props.fill : '#fff'} {...props}>
            <path id="ic24-search" d="M11,2a9,9,0,0,1,7.032,14.617l3.675,3.676a1,1,0,0,1-1.32,1.5l-.094-.083-3.676-3.675A9,9,0,1,1,11,2Zm0,2a7,7,0,1,0,7,7A7,7,0,0,0,11,4Z" transform="translate(-2 -2)" fill-rule="evenodd"/>
        </SvgIcon>
    )
}